import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { FormControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
import { forkJoin, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss']
})
export class ProfileListComponent implements OnInit, OnDestroy {
  filteredMatches: any[] = [];
  savedMatches: any[] = [];
  
  // Dropdown lists
  rasis: any[] = [];
  natchatras: any[] = [];
  gothrams: any[] = [];
  citys: any[] = [];
  districts: any[] = [];
  states: any[] = [];
  countrys: any[] = [];
  filteredStates: any[] = [];
filteredDistricts: any[] = [];
filteredCities: any[] = [];
  educations: any[] = [];
  highereducations: any[] = [];
  occupations: any[] = [];
  employmentypes: any[] = [];
  incomes: any[] = [];
  religions: any[] = [];
  castes: any[] = [];
  subcastes: any[] = [];
  languages: any[] = [];
  citizens: any[] = [];

  // Range values
  ageFromValues: number[] = [];
  ageToValues: number[] = [];
  heightFromValues: number[] = [];
  heightToValues: number[] = [];
  weightFromValues: number[] = [];
  weightToValues: number[] = [];
  salaryFromValues: number[] = [];
  salaryToValues: number[] = [];

  formGroup!: FormGroup;
  profileDetails: any;
  isGridView: boolean = true;
  favoriteProfiles: Set<string> = new Set<string>();
  base64Images: { [key: string]: string } = {};
  isFilterOpen: boolean = false;
  private favoritesSubscription?: Subscription;
  isSaveFilterPopupOpen = false;
  isSavedFiltersPanelOpen = false;
  filterName = '';
  savedFilters: any[] = [];
  loadingSavedFilters = false;
  loading = true;
  gender = '';
  isMobile: boolean = false;
  activeSavedFilterId: string | null = null;

  activeTab: string = 'basic';
  isFilterCollapsed: boolean = false;
  eduSearchQuery: string = '';
  higherEduSearchQuery: string = '';
  occSearchQuery: string = '';
  singleSearchQuery: string = '';
  activeDropdown: string | null = null;
  dropdownDirection: { [key: string]: 'up' | 'down' } = {};

  setTab(tabId: string) {
    this.activeTab = tabId;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.searchable-multi-select-container')) {
      this.activeDropdown = null;
    }
  }

  toggleFilterDropdown(dropdownId: string, event: MouseEvent) {
    event.stopPropagation();
    if (this.activeDropdown === dropdownId) {
      this.activeDropdown = null;
      return;
    }
    this.activeDropdown = dropdownId;
    this.singleSearchQuery = '';
    
    // Determine if dropdown should open upward or downward based on available viewport space
    const buttonRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const spaceBelow = window.innerHeight - buttonRect.bottom;
    const spaceAbove = buttonRect.top;
    const estimatedHeight = 310;

    if (spaceBelow < estimatedHeight && spaceAbove > spaceBelow) {
      this.dropdownDirection[dropdownId] = 'up';
    } else {
      this.dropdownDirection[dropdownId] = 'down';
    }
  }

  getSelectedEduCount(): number {
    const vals = this.formGroup?.value?.education;
    return Array.isArray(vals) ? vals.filter(Boolean).length : 0;
  }

  getSelectedHigherEduCount(): number {
    const vals = this.formGroup?.value?.highereducation;
    return Array.isArray(vals) ? vals.filter(Boolean).length : 0;
  }

  getSelectedEduLabel(): string {
    const count = this.getSelectedEduCount();
    if (count === 0) return 'Select Highest Qualification...';
    if (count === 1) {
      const idx = this.formGroup.value.education.findIndex((v: boolean) => v);
      return idx >= 0 && this.educations[idx] ? this.educations[idx].education_nme : `${count} Selected`;
    }
    return `${count} Qualifications Selected`;
  }

  getSelectedHigherEduLabel(): string {
    const count = this.getSelectedHigherEduCount();
    if (count === 0) return 'Select Higher / Postgraduate...';
    if (count === 1) {
      const idx = this.formGroup.value.highereducation.findIndex((v: boolean) => v);
      return idx >= 0 && this.highereducations[idx] ? this.highereducations[idx].highereducation_nme : `${count} Selected`;
    }
    return `${count} Qualifications Selected`;
  }

  isOccSelected(id: string): boolean {
    const vals = this.formGroup?.value?.occupation;
    return Array.isArray(vals) && vals.includes(id);
  }

  toggleOccupation(id: string) {
    const vals = Array.isArray(this.formGroup?.value?.occupation) ? [...this.formGroup.value.occupation] : [];
    const idx = vals.indexOf(id);
    if (idx >= 0) {
      vals.splice(idx, 1);
    } else {
      vals.push(id);
    }
    this.formGroup.get('occupation')?.setValue(vals);
  }

  getSelectedOccCount(): number {
    const vals = this.formGroup?.value?.occupation;
    return Array.isArray(vals) ? vals.filter(Boolean).length : 0;
  }

  getSelectedOccLabel(): string {
    const count = this.getSelectedOccCount();
    if (count === 0) return 'Any Occupation';
    if (count === 1) {
      const vals = this.formGroup?.value?.occupation;
      const found = this.occupations.find(o => o._id === vals[0]);
      return found ? (found.occupation_nme || found.occupation_name) : '1 Selected';
    }
    return `${count} Occupations Selected`;
  }

  setSingleSelect(controlName: string, value: any) {

  this.formGroup.get(controlName)?.setValue(value);

  // Country selected
  if (controlName === 'country') {

  this.formGroup.patchValue({
    state: '',
    district: '',
    city: ''
  });


  const selectedCountry = this.countrys.find(
    c => c._id === value
  );


  if (selectedCountry) {

    this.filteredStates = this.states.filter(
      s => s.country_id === selectedCountry.country_id
    );

  } else {
    this.filteredStates = [];
  }


  this.filteredDistricts = [];
  this.filteredCities = [];
}


  // State selected
  if (controlName === 'state') {

  this.formGroup.patchValue({
    district: '',
    city: ''
  });


  const selectedState = this.states.find(
    s => s._id === value
  );


  if (selectedState) {

    this.filteredDistricts = this.districts.filter(
      d => d.state_id === selectedState.state_id
    );

  } else {
    this.filteredDistricts = [];
  }


  this.filteredCities = [];
}


  // District selected
  if (controlName === 'district') {

  this.formGroup.patchValue({
    city: ''
  });


  const selectedDistrict = this.districts.find(
    d => d._id === value
  );


  if (selectedDistrict) {

    this.filteredCities = this.citys.filter(
      c =>
        c.ref_district_id === selectedDistrict._id ||
        c.ref_district_id === selectedDistrict.id_2 ||
        c.id_2 === selectedDistrict.id_2
    );

  } else {
    this.filteredCities = [];
  }

}


  // Reset dependent lists when clearing
  if (!value) {

    if (controlName === 'country') {
      this.filteredStates = [...this.states];
      this.filteredDistricts = [...this.districts];
      this.filteredCities = [...this.citys];
    }


    if (controlName === 'state') {
      this.filteredDistricts = [...this.districts];
      this.filteredCities = [...this.citys];
    }


    if (controlName === 'district') {
      this.filteredCities = [...this.citys];
    }

  }


  this.activeDropdown = null;
}

  isMultiSelected(controlName: string, id: string): boolean {
    const vals = this.formGroup?.value?.[controlName];
    return Array.isArray(vals) && vals.includes(id);
  }

  toggleMultiSelect(controlName: string, id: string) {
    const vals = Array.isArray(this.formGroup?.value?.[controlName]) ? [...this.formGroup.value[controlName]] : [];
    const idx = vals.indexOf(id);
    if (idx >= 0) {
      vals.splice(idx, 1);
    } else {
      vals.push(id);
    }
    this.formGroup.get(controlName)?.setValue(vals);
  }

  getMultiSelectLabel(controlName: string, fallback: string, list: any[], keyName: string): string {
    const vals = this.formGroup?.value?.[controlName];
    if (!Array.isArray(vals) || vals.length === 0) return fallback;
    if (vals.length === 1) {
      const found = list.find(item => item._id === vals[0]);
      return found ? (found[keyName] || found.employment_type_nme || found.employment_name || found.income_name || found.income_nme || found.occupation_nme || found.occupation_name || found.religion_nme || found.caste_nme || found.subcaste_nme || found.language_nme || found.name) : fallback;
    }
    return `${vals.length} Selected`;
  }

  getSingleSelectLabel(controlName: string, fallback: string): string {
    const val = this.formGroup?.value?.[controlName];
    if (val === null || val === undefined || val === '') return fallback;
    
    switch (controlName) {
      case 'heightfrom':
      case 'heightto':
        return `${val} cm`;
      case 'agefrom':
      case 'ageto':
        return `${val} yrs`;
      case 'salaryfrom':
      case 'salaryto':
        return `${(Number(val) / 100000).toFixed(1)}L`;
      case 'religion': {
        const found = this.religions.find(r => r._id === val);
        return found ? (found.religion_nme || found.religion_name) : fallback;
      }
      case 'caste': {
        const found = this.castes.find(c => c._id === val);
        return found ? (found.caste_nme || found.caste_name) : fallback;
      }
      case 'subcaste': {
        const found = this.subcastes.find(s => s._id === val);
        return found ? (found.subcaste_nme || found.subcaste_name) : fallback;
      }
      case 'language': {
        const found = this.languages.find(l => l._id === val);
        return found ? (found.language_nme || found.mother_tongue || found.name) : fallback;
      }
      case 'employmentype': {
        const found = this.employmentypes.find(e => e._id === val);
        return found ? (found.employment_type_nme || found.employment_name) : fallback;
      }
      case 'country': {
        const found = this.countrys.find(c => c._id === val);
        return found ? (found.country_nme || found.name_0 || found.country_name || found.name) : fallback;
      }
      case 'citizen': {
        const found = this.citizens.find(c => c._id === val);
        return found ? (found.citizenship_nme || found.name) : fallback;
      }
      case 'state': {
        const found = this.states.find(s => s._id === val);
        return found ? (found.name_1 || found.state_nme || found.state_name || found.name) : fallback;
      }
      case 'district': {
        const found = this.districts.find(d => d._id === val);
        return found ? (found.name_2 || found.district_nme || found.district_name || found.name) : fallback;
      }
      case 'city': {
        const found = this.citys.find(c => c._id === val);
        return found ? (found.city_nme || found.city_name || found.name) : fallback;
      }
      case 'smoking':
        return val === 'No' ? 'Non-Smoker' : val === 'Yes' ? 'Smoker' : fallback;
      case 'drinking':
        return val === 'No' ? 'Non-Drinker' : val === 'Yes' ? 'Drinker' : fallback;
      case 'rasi': {
        const found = this.rasis.find(r => r._id === val);
        return found ? found.rasi_nme : fallback;
      }
      case 'natchra': {
        const found = this.natchatras.find(n => n._id === val);
        return found ? found.natchr_nme : fallback;
      }
      case 'gothram': {
        const found = this.gothrams.find(g => g._id === val);
        return found ? found.gothram_nme : fallback;
      }
      case 'dosham':
        return val === 'Yes' ? 'Yes (Dosham)' : val === 'No' ? 'No Dosham' : val;
      default:
        return val;
    }
  }

  get isLoggedIn(): boolean {
    return !!localStorage.getItem('sessionToken');
  }

  getMaskedName(profile: any): string {
    if (this.isLoggedIn) {
      return `${profile.basic_info?.first_name || ''} ${profile.basic_info?.last_name || ''}`.trim();
    }
    const firstName = profile.basic_info?.first_name || '';
    const lastName = profile.basic_info?.last_name || '';
    const lastInitial = lastName ? lastName.charAt(0) + '.' : '';
    return `${firstName} ${lastInitial}`.trim() || 'Profile';
  }

  redirectToSignup() {
    Swal.fire({
      title: 'Sign Up Required',
      text: 'Please sign up or sign in to view complete profile details, shortlist, and chat.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Join Free',
      cancelButtonText: 'Sign In',
      confirmButtonColor: '#800020',
      cancelButtonColor: '#C5A059'
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['/signup-basic']);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.router.navigate(['/login']);
      }
    });
  }

  getCasteName(profile: any): string {
    const caste = profile.religion_info?.caste_id;
    if (!caste) return '';
    if (typeof caste === 'object') return caste.caste_nme || '';
    const found = this.castes.find(c => c._id === caste);
    return found ? found.caste_nme : '';
  }

  getOccupationName(profile: any): string {
    const occ = profile.professional_info?.occupation_id;
    if (!occ) return '';
    if (typeof occ === 'object') return occ.occupation_name || '';
    const found = this.occupations.find(o => o._id === occ);
    return found ? found.occupation_name : '';
  }

  getEducationName(profile: any): string {
    const edu = profile.professional_info?.education_id;
    if (!edu) return '';
    if (typeof edu === 'object') return edu.education_nme || '';
    const found = this.educations.find(e => e._id === edu);
    return found ? found.education_nme : '';
  }

  getReligionName(profile: any): string {
    const rel = profile.religion_info?.religion_id;
    if (!rel) return '';
    if (typeof rel === 'object') return rel.religion_nme || '';
    const found = this.religions.find(r => r._id === rel);
    return found ? found.religion_nme : '';
  }

  getLocationName(profile: any): string {
    const city = profile.residing_location?.city_id;
    if (!city) return '';
    if (typeof city === 'object') return city.city_nme || '';
    const found = this.citys.find(c => c._id === city);
    return found ? found.city_nme : '';
  }

  constructor(
    private apiService: ApiServiceService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.initForm();
    this.setupFormListeners();
  }

  private initForm() {
    this.formGroup = this.formBuilder.group({
      rasi: [''],
      natchra: [''],
      gothram: [''],
      dosham: [''],
      city: [''],
      district: [''],
      state: [''],
      country: [''],
      location: [''],
      education: this.formBuilder.array([]),
      highereducation: this.formBuilder.array([]),
      occupation: [[]],
      employmentype: [[]],
      income: [[]],
      smoking: [''],
      drinking: [''],
      food: [''],
      religion: [[]],
      caste: [[]],
      subcaste: [[]],
      agefrom: [''],
      ageto: [''],
      heightfrom: [''],
      heightto: [''],
      weightfrom: [''],
      weightto: [''],
      salaryfrom: [''],
      salaryto: [''],
      language: [[]],
      citizen: [''],
      physical: [''],
      familytype: [''],
      marital: ['']
    });
  }

  private setupFormListeners() {
    this.formGroup.get('agefrom')?.valueChanges.subscribe(value => this.updateAgeToValues(value));
    this.formGroup.get('heightfrom')?.valueChanges.subscribe(value => this.updateHeightToValues(value));
    this.formGroup.get('weightfrom')?.valueChanges.subscribe(value => this.updateWeightToValues(value));
    this.formGroup.get('salaryfrom')?.valueChanges.subscribe(value => this.updateSalaryToValues(value));
  }

  ngOnInit() {
    this.checkScreenSize();
    this.loading = true;
    this.initializeRanges();
    this.loadFavorites();
    this.favoritesSubscription = this.apiService.favoritesChanged.subscribe(evt => {
      if (evt.action === 'add') {
        this.favoriteProfiles.add(evt.profileId);
      } else {
        this.favoriteProfiles.delete(evt.profileId);
      }
    });
    this.loadSavedFilters();

    // Fetch master lists
    forkJoin([
      this.apiService.getRasi(),
      this.apiService.getNatchra(),
      this.apiService.getGothrams(),
      this.apiService.getCity(),
      this.apiService.getDistrict(),
      this.apiService.getState(),
      this.apiService.getCountry(),
      this.apiService.getEducation(),
      this.apiService.getHigherEducation(),
      this.apiService.getOccupation(),
      this.apiService.getEmploymentType(),
      this.apiService.getReligions(),
      this.apiService.getCastes(),
      this.apiService.getSubCastes(),
      this.apiService.getLanguages(),
      this.apiService.getCitizens(),
      this.apiService.getIncome()
    ]).subscribe(
      ([
        rasisRes, natchatrasRes, gothramsRes, citysRes, districtsRes,
        statesRes, countrysRes, educationsRes, highereducationsRes,
        occupationsRes, employmentypesRes, religionsRes, castesRes,
        subcastesRes, languagesRes, citizensRes, incomesRes
      ]) => {
        this.rasis = rasisRes.data || [];
        this.natchatras = natchatrasRes.data || [];
        this.gothrams = gothramsRes.data || [];
        this.citys = citysRes.data || [];
        this.districts = districtsRes.data || [];
        this.states = statesRes.data || [];
        this.countrys = countrysRes.data || [];
        this.filteredStates = [...this.states];
this.filteredDistricts = [...this.districts];
this.filteredCities = [...this.citys];
        this.educations = educationsRes.data || [];
        this.highereducations = highereducationsRes.data || [];
        this.occupations = occupationsRes.data || [];
        this.employmentypes = employmentypesRes.data || [];
        this.incomes = incomesRes?.data || [];
        this.religions = religionsRes.data || [];
        this.castes = castesRes.data || [];
        this.subcastes = subcastesRes.data || [];
        this.languages = languagesRes.data || [];
        this.citizens = citizensRes.data || [];

        // Build Checkboxes for educations
        const eduArray = this.formGroup.get('education') as FormArray;
        eduArray.clear();
        this.educations.forEach(() => eduArray.push(this.formBuilder.control(false)));

        const higherEduArray = this.formGroup.get('highereducation') as FormArray;
        higherEduArray.clear();
        this.highereducations.forEach(() => higherEduArray.push(this.formBuilder.control(false)));

        // Load Query Params or Partner Details
        this.route.queryParams.subscribe(params => {
          const filterId = params['filterId'];
          const lookingFor = params['lookingFor'];
          const ageFrom = params['ageFrom'];
          const ageTo = params['ageTo'];
          const religion = params['religion'];
          const location = params['location'];

          if (filterId) {
            this.loadSavedFilter(filterId);
          } else if (lookingFor || ageFrom || ageTo || religion || location) {
            this.prefillFromSearchParams(lookingFor, ageFrom, ageTo, religion, location);
            this.applyFilter();
            this.loading = false;
          } else {
            this.loadPartnerPreferences();
          }
        });
      },
      (error) => {
        console.error('Error loading master data:', error);
        this.loading = false;
      }
    );
  }

  private initializeRanges() {
    for (let i = 18; i <= 70; i++) this.ageFromValues.push(i);
    for (let i = 120; i <= 220; i++) this.heightFromValues.push(i);
    for (let i = 35; i <= 150; i++) this.weightFromValues.push(i);
    this.salaryFromValues = [100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 1000000, 1200000, 1500000, 2000000, 2500000, 3000000, 3500000, 5000000, 7500000, 10000000];
  }

  updateAgeToValues(from: number) {
    this.ageToValues = this.ageFromValues.filter(age => age > from);
    const toCtrl = this.formGroup.get('ageto');
    if (toCtrl?.value && Number(toCtrl.value) <= Number(from)) {
      toCtrl.setValue('');
    }
  }

  updateHeightToValues(from: number) {
    this.heightToValues = this.heightFromValues.filter(h => h > from);
    const toCtrl = this.formGroup.get('heightto');
    if (toCtrl?.value && Number(toCtrl.value) <= Number(from)) {
      toCtrl.setValue('');
    }
  }

  updateWeightToValues(from: number) {
    this.weightToValues = this.weightFromValues.filter(w => w > from);
    const toCtrl = this.formGroup.get('weightto');
    if (toCtrl?.value && Number(toCtrl.value) <= Number(from)) {
      toCtrl.setValue('');
    }
  }

  updateSalaryToValues(from: number) {
    this.salaryToValues = this.salaryFromValues.filter(s => s > from);
    const toCtrl = this.formGroup.get('salaryto');
    if (toCtrl?.value && Number(toCtrl.value) <= Number(from)) {
      toCtrl.setValue('');
    }
  }

  private prefillFromSearchParams(lookingFor: string, ageFrom: string, ageTo: string, religion: string, location: string) {
    const genderVal = lookingFor === 'Women' ? 'Female' : (lookingFor === 'Men' ? 'Male' : '');
    this.gender = genderVal;
    
    // Find matching religion Object _id
    let relId = '';
    if (religion && religion !== 'Any Religion') {
      const match = this.religions.find(r => (r.religion_nme || r.religion_name || '').toLowerCase() === religion.toLowerCase());
      if (match) relId = match._id;
    }

    // Find matching city
    let cityId = '';
    if (location) {
      const match = this.citys.find(c => (c.city_nme || c.city_name || '').toLowerCase().includes(location.toLowerCase()));
      if (match) cityId = match._id;
    }

    this.formGroup.patchValue({
      marital: genderVal ? '' : '', // reset
      agefrom: ageFrom ? Number(ageFrom) : '',
      ageto: ageTo ? Number(ageTo) : '',
      religion: relId ? [relId] : [],
      city: cityId || ''
    });
  }

  private loadPartnerPreferences() {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');
    if (sessionToken && profileId) {
      this.apiService.getPartnerDetails(sessionToken, profileId).subscribe(
        (response) => {
          this.profileDetails = response.data;
          this.setDefaultValues();
          this.applyFilter();
          this.loading = false;
        },
        (error) => {
          console.error('Error fetching partner details:', error);
          this.applyFilter(); // Fallback to empty filter
          this.loading = false;
        }
      );
    } else {
      this.applyFilter();
      this.loading = false;
    }
  }

  private setDefaultValues() {
    if (!this.profileDetails) return;

    const toArray = (v: any) => {
      if (!v) return [];
      if (Array.isArray(v)) return v.map(item => typeof item === 'object' && item ? item._id : item);
      return [typeof v === 'object' ? v._id : v];
    };

    if (this.profileDetails.horoscope_preference) {
      this.formGroup.patchValue({
        rasi: this.profileDetails.horoscope_preference.rasi_id?._id || '',
        natchra: this.profileDetails.horoscope_preference.natchr_id?._id || '',
        gothram: this.profileDetails.horoscope_preference.gothrm_id?._id || '',
        dosham: this.profileDetails.horoscope_preference.dosham || ''
      });
    }

    if (this.profileDetails.lifestyle_and_food_preference) {
      this.formGroup.patchValue({
        smoking: this.profileDetails.lifestyle_and_food_preference.smoking || '',
        drinking: this.profileDetails.lifestyle_and_food_preference.drinking || '',
        food: this.profileDetails.lifestyle_and_food_preference.food || ''
      });
    }

    if (this.profileDetails.religious_preference) {
      this.formGroup.patchValue({
        religion: toArray(this.profileDetails.religious_preference.religion_id),
        caste: toArray(this.profileDetails.religious_preference.caste_id),
        subcaste: toArray(this.profileDetails.religious_preference.sub_caste_id)
      });
    }

    if (this.profileDetails.profession_preference) {
      this.formGroup.patchValue({
        occupation: toArray(this.profileDetails.profession_preference.occupation_id),
        employmentype: toArray(this.profileDetails.profession_preference.employmentype_id),
        income: toArray(this.profileDetails.profession_preference.income_id)
      });
    }

    if (this.profileDetails.personal_preference) {
      this.formGroup.patchValue({
        agefrom: this.profileDetails.personal_preference.age_from || '',
        ageto: this.profileDetails.personal_preference.age_to || '',
        heightfrom: this.profileDetails.personal_preference.height_from || '',
        heightto: this.profileDetails.personal_preference.height_to || '',
        weightfrom: this.profileDetails.personal_preference.weight_from || '',
        weightto: this.profileDetails.personal_preference.weight_to || '',
        salaryfrom: this.profileDetails.personal_preference.salary_from || '',
        salaryto: this.profileDetails.personal_preference.salary_to || '',
        language: toArray(this.profileDetails.personal_preference.language_id),
        citizen: this.profileDetails.personal_preference.citizenship_id?._id || '',
        physical: this.profileDetails.personal_preference.physical_status || '',
        familytype: this.profileDetails.personal_preference.family_type || '',
        marital: this.profileDetails.personal_preference.marital_status || ''
      });
    }
  }

  loadSavedFilter(filterId: string) {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');
    if (sessionToken && profileId) {
      this.apiService.getSaveFilters(sessionToken, profileId).subscribe(
        response => {
          if (response.status === 'success' && Array.isArray(response.data)) {
            this.savedFilters = response.data;
            const savedFilter = response.data.find((f: any) => f._id === filterId);
            if (savedFilter) {
              this.activeSavedFilterId = filterId;
              this.patchSavedFilterValues(savedFilter);
              this.applyFilter();
            }
          }
          this.loading = false;
        },
        error => {
          console.error('Error fetching saved filter:', error);
          this.loading = false;
        }
      );
    }
  }

  loadSavedFilters() {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');
    if (!sessionToken || !profileId) return;
    this.loadingSavedFilters = true;
    this.apiService.getSaveFilters(sessionToken, profileId).subscribe(
      response => {
        this.savedFilters = response.status === 'success' && Array.isArray(response.data) ? response.data : [];
        this.loadingSavedFilters = false;
      },
      () => { this.loadingSavedFilters = false; }
    );
  }

  toggleSavedFiltersPanel() {
    this.isSavedFiltersPanelOpen = !this.isSavedFiltersPanelOpen;
    if (this.isSavedFiltersPanelOpen && this.savedFilters.length === 0) {
      this.loadSavedFilters();
    }
  }

  applySavedFilter(filter: any) {
    this.activeSavedFilterId = filter._id;
    this.patchSavedFilterValues(filter);
    this.applyFilter();
    this.isSavedFiltersPanelOpen = false;
    Swal.fire({
      title: 'Filter Applied',
      text: `"${filter.filter_name}" is now active.`,
      icon: 'success',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 1800
    });
  }

  editSavedFilter(filter: any) {
    Swal.fire({
      title: 'Rename Filter',
      input: 'text',
      inputValue: filter.filter_name,
      inputLabel: 'New filter name',
      showCancelButton: true,
      confirmButtonText: 'Save',
      confirmButtonColor: '#8c002a',
      inputValidator: (value) => !value ? 'Please enter a name.' : null
    }).then(result => {
      if (result.isConfirmed && result.value) {
        const sessionToken = localStorage.getItem('sessionToken') || '';
        this.apiService.updateFilter(sessionToken, filter._id, { filter_name: result.value }).subscribe(
          () => {
            filter.filter_name = result.value;
            Swal.fire({ title: 'Renamed!', icon: 'success', timer: 1500, showConfirmButton: false, toast: true, position: 'top-end' });
          },
          err => {
            console.error('Error updating filter:', err);
            Swal.fire('Error', 'Could not rename the filter.', 'error');
          }
        );
      }
    });
  }

  deleteSavedFilter(filterId: string) {
    Swal.fire({
      title: 'Delete Filter?',
      text: 'This saved filter will be permanently deleted.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      confirmButtonColor: '#8c002a'
    }).then(result => {
      if (result.isConfirmed) {
        const sessionToken = localStorage.getItem('sessionToken') || '';
        this.apiService.deleteFilter(sessionToken, filterId).subscribe(
          () => {
            this.savedFilters = this.savedFilters.filter(f => f._id !== filterId);
            if (this.activeSavedFilterId === filterId) this.activeSavedFilterId = null;
            Swal.fire({ title: 'Deleted!', icon: 'success', timer: 1500, showConfirmButton: false, toast: true, position: 'top-end' });
          },
          err => {
            console.error('Error deleting filter:', err);
            Swal.fire('Error', 'Could not delete the filter.', 'error');
          }
        );
      }
    });
  }

  getSavedFilterSummary(filter: any): string {
    const parts: string[] = [];
    const pf = filter.personal_filter;
    if (pf?.age_from || pf?.age_to) {
      parts.push(`Age ${pf.age_from || '?'}–${pf.age_to || '?'}`);
    }
    const rel = filter.religious_filter?.religion_id;
    if (rel) {
      const relIds = Array.isArray(rel) ? rel : [rel];
      const relNames = relIds.map(id => {
        const found = this.religions.find((r: any) => r._id === id || r._id?.toString() === id?.toString());
        return found ? (found.religion_nme || found.religion_name) : '';
      }).filter(Boolean);
      if (relNames.length > 0) parts.push(relNames.join(', '));
    }
    const caste = filter.religious_filter?.caste_id;
    if (caste) {
      const casteIds = Array.isArray(caste) ? caste : [caste];
      const casteNames = casteIds.map(id => {
        const found = this.castes.find((c: any) => c._id === id || c._id?.toString() === id?.toString());
        return found ? (found.caste_nme || found.caste_name) : '';
      }).filter(Boolean);
      if (casteNames.length > 0) parts.push(casteNames.join(', '));
    }
    const city = filter.location_filter?.city_id;
    if (city) {
      const found = this.citys.find((c: any) => c._id === city || c._id?.toString() === city?.toString());
      if (found) parts.push(found.city_nme);
    }
    const food = filter.lifestyle_and_food_filter?.food;
    if (food) parts.push(food);
    return parts.length > 0 ? parts.join(' · ') : 'No criteria set';
  }

  private patchSavedFilterValues(savedFilter: any) {
    const toArray = (v: any) => {
      if (!v) return [];
      if (Array.isArray(v)) return v;
      return [v];
    };

    this.formGroup.patchValue({
      rasi: savedFilter.horoscope_filter?.rasi_id || '',
      natchra: savedFilter.horoscope_filter?.natchr_id || '',
      gothram: savedFilter.horoscope_filter?.gothrm_id || '',
      dosham: savedFilter.horoscope_filter?.dosham || '',
      city: savedFilter.location_filter?.city_id || '',
      district: savedFilter.location_filter?.dist_id || '',
      state: savedFilter.location_filter?.state_id || '',
      country: savedFilter.location_filter?.country_id || '',
      location: savedFilter.location_filter?.location_proximity || '',
      smoking: savedFilter.lifestyle_and_food_filter?.smoking || '',
      drinking: savedFilter.lifestyle_and_food_filter?.drinking || '',
      food: savedFilter.lifestyle_and_food_filter?.food || '',
      religion: toArray(savedFilter.religious_filter?.religion_id),
      caste: toArray(savedFilter.religious_filter?.caste_id),
      subcaste: toArray(savedFilter.religious_filter?.sub_caste_id),
      agefrom: savedFilter.personal_filter?.age_from || '',
      ageto: savedFilter.personal_filter?.age_to || '',
      heightfrom: savedFilter.personal_filter?.height_from || '',
      heightto: savedFilter.personal_filter?.height_to || '',
      weightfrom: savedFilter.personal_filter?.weight_from || '',
      weightto: savedFilter.personal_filter?.weight_to || '',
      salaryfrom: savedFilter.personal_filter?.salary_from || '',
      salaryto: savedFilter.personal_filter?.salary_to || '',
      language: toArray(savedFilter.personal_filter?.language_id),
      citizen: savedFilter.personal_filter?.citizenship_id || '',
      physical: savedFilter.personal_filter?.physical_status || '',
      familytype: savedFilter.personal_filter?.family_type || '',
      marital: savedFilter.personal_filter?.marital_status || '',
      occupation: toArray(savedFilter.profession_filter?.occupation_id),
      employmentype: toArray(savedFilter.profession_filter?.employmentype_id),
      income: toArray(savedFilter.profession_filter?.income_id)
    });
  }

  get selectedQualifications(): string[] {
    return this.highereducations
      .filter((_, i) => this.formGroup.value.highereducation[i])
      .map(q => q._id);
  }

  get selectedEducations(): string[] {
    return this.educations
      .filter((_, i) => this.formGroup.value.education[i])
      .map(e => e._id);
  }

  getFilterPayload() {
    const formData = this.formGroup.value;
    const profileId = localStorage.getItem('profileId') || '000000000000000000000000';

    return {
      action: 'find_all',
      type: 'filter',
      profileId: profileId,
      data: {
        filter_name: '',
        horoscope_filter: {
          rasi_id: formData.rasi,
          natchr_id: formData.natchra,
          gothrm_id: formData.gothram,
          dosham: formData.dosham
        },
        location_filter: {
          city_id: formData.city,
          dist_id: formData.district,
          state_id: formData.state,
          country_id: formData.country,
          location_proximity: formData.location
        },
        education_filter: {
          education_id: this.selectedEducations,
          higher_education_id: this.selectedQualifications
        },
        profession_filter: {
          occupation_id: formData.occupation,
          employmentype_id: formData.employmentype,
          income_id: formData.income
        },
        lifestyle_and_food_filter: {
          smoking: formData.smoking,
          drinking: formData.drinking,
          food: formData.food
        },
        religious_filter: {
          religion_id: formData.religion,
          caste_id: formData.caste,
          sub_caste_id: formData.subcaste
        },
        personal_filter: {
          gender: this.gender,
          age_from: formData.agefrom,
          age_to: formData.ageto,
          height_from: formData.heightfrom,
          height_to: formData.heightto,
          weight_from: formData.weightfrom,
          weight_to: formData.weightto,
          salary_from: formData.salaryfrom,
          salary_to: formData.salaryto,
          language_id: formData.language,
          citizenship_id: formData.citizen,
          physical_status: formData.physical,
          family_type: formData.familytype,
          marital_status: formData.marital
        }
      }
    };
  }

  applyFilter() {
    this.loading = true;
    const sessionToken = localStorage.getItem('sessionToken') || '';
    const payload = this.getFilterPayload();

    if (!payload) {
      this.loading = false;
      return;
    }

    this.apiService.getfilterMatches(sessionToken, payload).subscribe(
      response => {
        if (response.status === 'success' && Array.isArray(response.data)) {
          this.filteredMatches = response.data;
          console.log(`[Search Filters] API Returned: ${response.data.length} profiles.`);
          this.base64Images = {}; // Clear old caches
          this.filteredMatches.forEach(profile => {
            const idKey = profile.basic_info?.keycloak_id || profile.basic_info?.ory_identity_id || profile._id;
            if (idKey && profile.personal_info?.avatar_Id) {
              const imgUrl = `${idKey}/gallery/avatar/${profile.personal_info.avatar_Id}`;
              this.loadImage(imgUrl, profile._id);
            }
          });
          this.syncInterestStatuses();
        } else {
          this.filteredMatches = [];
          console.log(`[Search Filters] API Returned: 0 profiles.`);
        }
        this.loading = false;
        
        // Collapse filter on mobile after apply to free screen space
        if (this.isMobile && this.isFilterOpen) {
          this.isFilterOpen = false;
        }
      },
      error => {
        console.error('Error fetching filtered matches:', error);
        this.loading = false;
      }
    );
  }

  loadImage(imagePath: string, profileId: string): void {
    if (this.base64Images[profileId]) return;
    this.apiService.getImageBase64(imagePath).subscribe(
      (data) => {
        if (data && data.base64Image) {
          this.base64Images[profileId] = data.base64Image;
        }
      },
      (error) => {
        console.error('Error loading image base64:', error);
      }
    );
  }

  toggleFavorite(profileId: string) {
    profileId = String(profileId);
    if (this.isFavorite(profileId)) {
      this.removeFavorite(profileId);
    } else {
      this.addFavorite(profileId);
    }
  }

  isFavorite(profileId: string): boolean {
    return this.favoriteProfiles.has(String(profileId));
  }

  private addFavorite(profileId: string) {
    profileId = String(profileId);
    if (this.favoriteProfiles.has(profileId)) return;
    const match = this.filteredMatches.find(p => String(p._id) === profileId);
    if (!match) return;

    const sessionToken = localStorage.getItem('sessionToken');
    const ownerId = localStorage.getItem('profileId');
    if (!sessionToken || !ownerId) return;

    this.favoriteProfiles.add(profileId);
    this.apiService.favoritesChanged.next({ profileId, action: 'add' });

    this.apiService.addToFavorites(sessionToken, profileId, ownerId, match.basic_info || {}, match.religion_info || {}).subscribe(
      response => {
        Swal.fire({
          title: 'Added to Shortlist',
          text: 'Profile added to your favorites successfully.',
          icon: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000
        });
      },
      error => {
        this.favoriteProfiles.delete(profileId);
        this.apiService.favoritesChanged.next({ profileId, action: 'remove' });
        if (this.apiService.handleQuotaError(error)) return;
        console.error('Error adding favorite:', error);
      }
    );
  }

  private removeFavorite(profileId: string) {
    profileId = String(profileId);
    if (!this.favoriteProfiles.has(profileId)) return;
    const sessionToken = localStorage.getItem('sessionToken');
    const ownerId = localStorage.getItem('profileId');
    if (!sessionToken || !ownerId) return;

    this.favoriteProfiles.delete(profileId);
    this.apiService.favoritesChanged.next({ profileId, action: 'remove' });

    this.apiService.deleteFavorite(sessionToken, profileId, ownerId).subscribe(
      response => {
        Swal.fire({
          title: 'Removed from Shortlist',
          text: 'Profile removed from your favorites successfully.',
          icon: 'info',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000
        });
      },
      error => {
        this.favoriteProfiles.add(profileId);
        this.apiService.favoritesChanged.next({ profileId, action: 'add' });
        console.error('Error deleting favorite:', error);
      }
    );
  }

  private loadFavorites() {
    const sessionToken = localStorage.getItem('sessionToken');
    const ownerId = localStorage.getItem('profileId');
    if (!sessionToken || !ownerId) return;
    this.apiService.getFavorites(sessionToken, ownerId).subscribe(
      response => {
        if (response.status === 'success' && Array.isArray(response.data)) {
          this.favoriteProfiles.clear();
          response.data.forEach((fav: any) => {
            const profileId = fav.selected_profile_id?._id || fav.selected_profile_id || fav.profile?._id || fav.profile;
            if (profileId) {
              this.favoriteProfiles.add(String(profileId));
            }
          });
        }
      },
      error => console.error('Error loading favorites:', error)
    );
  }

  private syncInterestStatuses(): void {
    const sessionToken = localStorage.getItem('sessionToken') || '';
    const ownerId = localStorage.getItem('profileId');

    if (!sessionToken || !ownerId) {
      this.filteredMatches.forEach(profile => profile.interest_status = null);
      return;
    }

    this.apiService.getSentConnectionList(sessionToken, ownerId).subscribe({
      next: (response: any) => {
        const connections = Array.isArray(response?.data) ? response.data : [];
        const statusMap = new Map<string, string | null>();

        connections.forEach((item: any) => {
          const targetProfile = item.selected_profile_id;
          const targetId = targetProfile && typeof targetProfile === 'object' ? targetProfile._id : targetProfile;
          const status = item.interest_status || null;
          if (targetId) {
            statusMap.set(String(targetId), status);
          }
        });

        this.filteredMatches.forEach((profile: any) => {
          const profileId = String(profile._id || '');
          profile.interest_status = profileId ? (statusMap.get(profileId) || null) : null;
        });
      },
      error: (err) => {
        console.error('Error loading connection statuses:', err);
        this.filteredMatches.forEach((profile: any) => profile.interest_status = null);
      }
    });
  }

  private updateProfileInterestStatus(profileId: string, status: string | null): void {
    const profile = this.filteredMatches.find(p => String(p._id) === String(profileId));
    if (profile) {
      profile.interest_status = status;
    }
  }
  goBack(): void {
  this.location.back();
}

  ngOnDestroy(): void {
    this.favoritesSubscription?.unsubscribe();
  }

  sendInterest(profileId: string) {
    const sessionToken = localStorage.getItem('sessionToken');
    const ownerId = localStorage.getItem('profileId');
    if (!sessionToken || !ownerId) {
      this.router.navigate(['/login']);
      return;
    }

    this.apiService.setConnectionStatus(sessionToken, ownerId, profileId, 'Pending').subscribe(
      response => {
        Swal.fire({
          title: 'Interest Sent!',
          text: 'Connection request sent successfully.',
          icon: 'success',
          confirmButtonColor: '#800020'
        });
        this.updateProfileInterestStatus(profileId, 'Pending');
      },
      error => {
        if (this.apiService.handleQuotaError(error)) return;
        Swal.fire({
          title: 'Error',
          text: 'Could not send interest. Please try again.',
          icon: 'error',
          confirmButtonColor: '#800020'
        });
        console.error('Error sending interest:', error);
      }
    );
  }

  cancelInterest(profile: any) {
    Swal.fire({
      title: 'Revert Request?',
      text: `Are you sure you want to cancel the interest request sent to ${profile.basic_info?.first_name || 'this profile'}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#800020',
      confirmButtonText: 'Yes, Cancel Request'
    }).then((result) => {
      if (result.isConfirmed) {
        const sessionToken = localStorage.getItem('sessionToken');
        const ownerId = localStorage.getItem('profileId');
        if (!sessionToken || !ownerId) return;

        this.apiService.setConnectionStatus(sessionToken, ownerId, profile._id, 'Cancelled').subscribe(
          response => {
            Swal.fire({
              title: 'Cancelled',
              text: 'Your interest request has been reverted.',
              icon: 'success',
              confirmButtonColor: '#800020'
            });
            this.updateProfileInterestStatus(profile._id, null);
          },
          error => {
            console.error('Error cancelling interest:', error);
            Swal.fire('Error', 'Could not cancel request. Please try again.', 'error');
          }
        );
      }
    });
  }

  getAge(dateOfBirth: string): number {
    if (!dateOfBirth) return 0;
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  toggleViewMode() {
    this.isGridView = !this.isGridView;
  }

  toggleFilterPanel() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  get isFreePlan(): boolean {
    const plan = (localStorage.getItem('user_current_plan') || 'FREE').toUpperCase();
    return plan === 'FREE';
  }

  openSaveFilterPopup() {
    if (this.isFreePlan) {
      this.apiService.handleQuotaError({
        error: {
          code: 'LIMIT_REACHED',
          message: 'Saving search filters is not available on the Free plan. Upgrade your membership to save custom search criteria!'
        }
      });
      return;
    }
    this.isSaveFilterPopupOpen = true;
  }

  closeSaveFilterPopup() {
    this.isSaveFilterPopupOpen = false;
    this.filterName = '';
  }

  submitFilterName() {
    if (!this.filterName.trim()) {
      Swal.fire('Input Required', 'Please enter a filter name.', 'warning');
      return;
    }

    const sessionToken = localStorage.getItem('sessionToken');
    const payload = this.getFilterPayload();

    if (!sessionToken || !payload) return;

    payload.action = 'save';
    payload.type = 'filter';
    payload.data.filter_name = this.filterName;

    this.apiService.getsaveFilter(sessionToken, payload).subscribe(
      response => {
        if (response.status === 'success' && response.data) {
          this.savedFilters = [response.data, ...this.savedFilters];
        }
        Swal.fire({
          title: 'Filter Saved!',
          text: `Your filter "${this.filterName}" has been saved successfully.`,
          icon: 'success',
          confirmButtonColor: '#800020'
        });
        this.closeSaveFilterPopup();
      },
      (error: any) => {
        if (this.apiService.handleQuotaError(error)) {
          this.closeSaveFilterPopup();
          return;
        }
        console.error('Error saving filter:', error);
        const msg = error?.error?.data || 'An error occurred while saving the filter.';
        Swal.fire('Error', msg, 'error');
      }
    );
  }

  getActiveFilterCount(): number {
    const fv = this.formGroup?.value;
    if (!fv) return 0;
    let count = 0;
    const check = (v: any) => v !== '' && v !== null && v !== undefined;
    if (check(fv.marital)) count++;
    if (check(fv.agefrom) || check(fv.ageto)) count++;
    if (check(fv.heightfrom) || check(fv.heightto)) count++;
    if (check(fv.weightfrom) || check(fv.weightto)) count++;
    if (check(fv.physical)) count++;
    if (check(fv.familytype)) count++;
    if (check(fv.religion)) count++;
    if (check(fv.caste)) count++;
    if (check(fv.subcaste)) count++;
    if (check(fv.language)) count++;
    if (this.selectedEducations.length > 0) count++;
    if (this.selectedQualifications.length > 0) count++;
    if (check(fv.city)) count++;
    if (check(fv.state)) count++;
    if (check(fv.country)) count++;
    const occs = Array.isArray(fv.occupation) ? fv.occupation.filter((v: any) => v && v !== '') : [];
    if (occs.length > 0) count++;
    const emps = Array.isArray(fv.employmentype) ? fv.employmentype.filter((v: any) => v && v !== '') : [];
    if (emps.length > 0) count++;
    const incs = Array.isArray(fv.income) ? fv.income.filter((v: any) => v && v !== '') : [];
    if (incs.length > 0) count++;
    if (check(fv.salaryfrom) || check(fv.salaryto)) count++;
    if (check(fv.smoking)) count++;
    if (check(fv.drinking)) count++;
    if (check(fv.food)) count++;
    if (check(fv.rasi)) count++;
    if (check(fv.natchra)) count++;
    if (check(fv.gothram)) count++;
    if (check(fv.dosham)) count++;
    return count;
  }

  getActiveFilterSummary(): string[] {
    return this.getActiveFilterChips().map(c => c.label);
  }

  getActiveFilterChips(): { label: string, tab: string }[] {
    const fv = this.formGroup?.value;
    if (!fv) return [];
    const chips: { label: string, tab: string }[] = [];
    const check = (v: any) => v !== '' && v !== null && v !== undefined;

    if (check(fv.agefrom) || check(fv.ageto)) chips.push({ label: `Age ${fv.agefrom || '?'}–${fv.ageto || '?'}`, tab: 'basic' });
    if (check(fv.heightfrom) || check(fv.heightto)) chips.push({ label: `Height ${fv.heightfrom || '?'}–${fv.heightto || '?'} cm`, tab: 'basic' });
    if (check(fv.weightfrom) || check(fv.weightto)) chips.push({ label: `Weight ${fv.weightfrom || '?'}–${fv.weightto || '?'} kg`, tab: 'basic' });
    if (check(fv.marital)) chips.push({ label: fv.marital, tab: 'basic' });
    if (check(fv.physical)) chips.push({ label: fv.physical, tab: 'basic' });
    if (check(fv.familytype)) chips.push({ label: fv.familytype, tab: 'basic' });
    const langs = Array.isArray(fv.language) ? fv.language.filter((v: any) => v && v !== '') : (check(fv.language) ? [fv.language] : []);
    if (langs.length > 0) {
      const l = this.languages?.find((x: any) => x._id === langs[0]);
      chips.push({ label: langs.length === 1 && l ? l.language_nme : `${langs.length} language(s)`, tab: 'basic' });
    }

    const rels = Array.isArray(fv.religion) ? fv.religion.filter((v: any) => v && v !== '') : (check(fv.religion) ? [fv.religion] : []);
    if (rels.length > 0) {
      const r = this.religions?.find((x: any) => x._id === rels[0]);
      chips.push({ label: rels.length === 1 && r ? r.religion_nme : `${rels.length} religion(s)`, tab: 'faith' });
    }
    const castes = Array.isArray(fv.caste) ? fv.caste.filter((v: any) => v && v !== '') : (check(fv.caste) ? [fv.caste] : []);
    if (castes.length > 0) {
      const c = this.castes?.find((x: any) => x._id === castes[0]);
      chips.push({ label: castes.length === 1 && c ? c.caste_nme : `${castes.length} caste(s)`, tab: 'faith' });
    }
    const subcastes = Array.isArray(fv.subcaste) ? fv.subcaste.filter((v: any) => v && v !== '') : (check(fv.subcaste) ? [fv.subcaste] : []);
    if (subcastes.length > 0) {
      const s = this.subcastes?.find((x: any) => x._id === subcastes[0]);
      chips.push({ label: subcastes.length === 1 && s ? s.subcaste_nme : `${subcastes.length} subcaste(s)`, tab: 'faith' });
    }

    if (this.selectedEducations?.length > 0) chips.push({ label: `${this.selectedEducations.length} education(s)`, tab: 'education' });
    if (this.selectedQualifications?.length > 0) chips.push({ label: `${this.selectedQualifications.length} higher edu`, tab: 'education' });

    const occs = Array.isArray(fv.occupation) ? fv.occupation.filter((v: any) => v && v !== '') : (check(fv.occupation) ? [fv.occupation] : []);
    if (occs.length > 0) {
      const o = this.occupations?.find((x: any) => x._id === occs[0]);
      chips.push({ label: occs.length === 1 && o ? (o.occupation_nme || o.occupation_name) : `${occs.length} occupation(s)`, tab: 'career' });
    }
    const emps = Array.isArray(fv.employmentype) ? fv.employmentype.filter((v: any) => v && v !== '') : (check(fv.employmentype) ? [fv.employmentype] : []);
    if (emps.length > 0) {
      const e = this.employmentypes?.find((x: any) => x._id === emps[0]);
      chips.push({ label: emps.length === 1 && e ? (e.employment_type_nme || e.employment_name) : `${emps.length} employment type(s)`, tab: 'career' });
    }
    const incs = Array.isArray(fv.income) ? fv.income.filter((v: any) => v && v !== '') : (check(fv.income) ? [fv.income] : []);
    if (incs.length > 0) {
      const inc = this.incomes?.find((x: any) => x._id === incs[0]);
      chips.push({ label: incs.length === 1 && inc ? (inc.income_name || inc.income_nme) : `${incs.length} income range(s)`, tab: 'career' });
    }
    if (check(fv.salaryfrom) || check(fv.salaryto)) chips.push({ label: `Income ${(fv.salaryfrom ? (fv.salaryfrom/100000).toFixed(1)+'L' : 'Min')}–${(fv.salaryto ? (fv.salaryto/100000).toFixed(1)+'L' : 'Max')}`, tab: 'career' });

    if (check(fv.country)) {
      const c = this.countrys?.find((x: any) => x._id === fv.country);
      if (c) chips.push({ label: c.country_nme || c.country_name || 'Country', tab: 'location' });
    }
    if (check(fv.state)) {
      const s = this.states?.find((x: any) => x._id === fv.state);
      if (s) chips.push({ label: s.state_nme || s.state_name || 'State', tab: 'location' });
    }
    if (check(fv.city)) {
      const c = this.citys?.find((x: any) => x._id === fv.city);
      if (c) chips.push({ label: c.city_nme || c.city_name || 'City', tab: 'location' });
    }
    if (check(fv.citizen)) {
      const c = this.citizens?.find((x: any) => x._id === fv.citizen);
      if (c) chips.push({ label: c.citizenship_nme || 'Citizenship', tab: 'location' });
    }

    if (check(fv.food)) chips.push({ label: fv.food, tab: 'lifestyle' });
    if (check(fv.smoking)) chips.push({ label: `Smoking: ${fv.smoking}`, tab: 'lifestyle' });
    if (check(fv.drinking)) chips.push({ label: `Drinking: ${fv.drinking}`, tab: 'lifestyle' });

    if (check(fv.rasi)) {
      const r = this.rasis?.find((x: any) => x._id === fv.rasi);
      if (r) chips.push({ label: r.rasi_nme, tab: 'horoscope' });
    }
    if (check(fv.natchra)) {
      const n = this.natchatras?.find((x: any) => x._id === fv.natchra);
      if (n) chips.push({ label: n.natchr_nme, tab: 'horoscope' });
    }
    if (check(fv.gothram)) {
      const g = this.gothrams?.find((x: any) => x._id === fv.gothram);
      if (g) chips.push({ label: g.gothram_nme, tab: 'horoscope' });
    }
    if (check(fv.dosham)) chips.push({ label: `Dosham: ${fv.dosham}`, tab: 'horoscope' });

    return chips;
  }

  onFilterChipClick(chip: { label: string, tab: string }) {
    this.isFilterCollapsed = false;
    this.setTab(chip.tab);
  }

  resetFilters() {
    this.formGroup.reset({
      rasi: '',
      natchra: '',
      gothram: '',
      dosham: '',
      city: '',
      district: '',
      state: '',
      country: '',
      location: '',
      occupation: [],
      employmentype: [],
      income: [],
      smoking: '',
      drinking: '',
      food: '',
      religion: [],
      caste: [],
      subcaste: [],
      agefrom: '',
      ageto: '',
      heightfrom: '',
      heightto: '',
      weightfrom: '',
      weightto: '',
      salaryfrom: '',
      salaryto: '',
      language: [],
      citizen: '',
      physical: '',
      familytype: '',
      marital: ''
    });
    const eduArray = this.formGroup.get('education') as FormArray;
    eduArray.controls.forEach(c => c.setValue(false));
    const higherEduArray = this.formGroup.get('highereducation') as FormArray;
    higherEduArray.controls.forEach(c => c.setValue(false));
    this.eduSearchQuery = '';
    this.higherEduSearchQuery = '';
    this.occSearchQuery = '';
    this.activeDropdown = null;
    this.activeSavedFilterId = null;
    this.applyFilter();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  isFeaturedProfile(profile: any): boolean {
    if (!profile) return false;
    if (profile.isFeatured !== undefined) return Boolean(profile.isFeatured);
    const plan = (profile.current_plan || '').toUpperCase();
    return plan !== 'FREE' && plan !== 'SILVER' && plan !== '';
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
  }
}
